import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Programma from "./pages/Programma";
import Strandbar from "./pages/Strandbar";
import Kinderstrand from "./pages/Kinderstrand";
import Sportstrand from "./pages/Sportstrand";
import Beachvolleybal from "./pages/Beachvolleybal";
import Partners from "./pages/Partners";
import Contact from "./pages/Contact";
import ComingSoonPage from "./pages/ComingSoonPage";
import Bereikbaarheid from "./pages/Bereikbaarheid";
import Vrijwilligers from "./pages/Vrijwilligers";
import Openingsuren from "./pages/Openingsuren";
import Menukaart from "./pages/Menukaart";
import LineUp from "./pages/LineUp";
import Fotos from "./pages/Fotos";
import Videos from "./pages/Videos";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/programma" element={<Programma />} />
            <Route path="/strandbar" element={<Strandbar />} />
            <Route path="/kinderstrand" element={<Kinderstrand />} />
            <Route path="/sportstrand" element={<Sportstrand />} />
            <Route path="/volleybal" element={<Beachvolleybal />} />
            <Route path="/beachvolleybal" element={<Beachvolleybal />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/line-up" element={<LineUp />} />
            <Route path="/vrijwilligers" element={<Vrijwilligers />} />
            <Route path="/media/fotos" element={<Fotos />} />
            <Route path="/media/video" element={<Videos />} />
            <Route path="/praktische-info/openingsuren" element={<Openingsuren />} />
            <Route path="/praktische-info/bereikbaarheid" element={<Bereikbaarheid />} />
            <Route path="/praktische-info/menukaart" element={<Menukaart />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
